var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "ui small modal", attrs: { id: "edit-customer-dialog" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _vm.form.model.id
          ? _c("div", { staticClass: "header" }, [_vm._v("顧客情報編集")])
          : _c("div", { staticClass: "header" }, [_vm._v("顧客情報新規作成")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "form",
            {
              staticClass: "ui form",
              class: { warning: _vm.form.hasErrors() },
            },
            [
              _c(
                "div",
                { staticClass: "required field" },
                [
                  _c("label", [_vm._v("顧客名")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.model.name,
                        expression: "form.model.name",
                      },
                    ],
                    attrs: { type: "text", placeholder: "顧客名" },
                    domProps: { value: _vm.form.model.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form.model, "name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("validation-message", {
                    attrs: { form: _vm.form, field: "name" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "required field" },
                [
                  _c("label", [_vm._v("メールアドレス")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.model.email,
                        expression: "form.model.email",
                      },
                    ],
                    attrs: { type: "text", placeholder: "メールアドレス" },
                    domProps: { value: _vm.form.model.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form.model, "email", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("validation-message", {
                    attrs: { form: _vm.form, field: "email" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "fields" }, [
                _c(
                  "div",
                  { staticClass: "required eight wide field" },
                  [
                    _c("label", [_vm._v("都道府県")]),
                    _vm._v(" "),
                    _c(
                      "dropdown",
                      {
                        attrs: { placeholder: "都道府県" },
                        on: {
                          change: function ($event) {
                            return _vm.onPrefectureChange()
                          },
                        },
                        model: {
                          value: _vm.form.model.prefecture,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.model, "prefecture", $$v)
                          },
                          expression: "form.model.prefecture",
                        },
                      },
                      _vm._l(_vm.consts.SHOP_PREFECTURE, function (each) {
                        return _c(
                          "option",
                          {
                            key: each.label,
                            attrs: { disabled: each.value === "" },
                            domProps: { value: each.value },
                          },
                          [_vm._v(_vm._s(each.label))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("validation-message", {
                      attrs: { form: _vm.form, field: "prefecture" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "required eight wide field" },
                  [
                    _c("label", [_vm._v("エリア")]),
                    _vm._v(" "),
                    _c(
                      "dropdown",
                      {
                        attrs: { placeholder: "エリア" },
                        on: { change: _vm.onAreaChange },
                        model: {
                          value: _vm.form.model.area,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.model, "area", $$v)
                          },
                          expression: "form.model.area",
                        },
                      },
                      _vm._l(_vm.areaOptions, function (each) {
                        return _c(
                          "option",
                          {
                            key: each.label,
                            attrs: { disabled: each.value === "" },
                            domProps: { value: each.value },
                          },
                          [_vm._v(_vm._s(each.label))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("validation-message", {
                      attrs: { form: _vm.form, field: "area" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "eight wide field" },
                  [
                    _c("label", [_vm._v("エリア詳細")]),
                    _vm._v(" "),
                    _c(
                      "dropdown",
                      {
                        ref: "areaDetail",
                        attrs: { placeholder: "エリア詳細" },
                        model: {
                          value: _vm.form.model.area_detail,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.model, "area_detail", $$v)
                          },
                          expression: "form.model.area_detail",
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("エリア詳細"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("validation-message", {
                      attrs: { form: _vm.form, field: "area_detail" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "checkbox",
                    {
                      ref: "subscribed",
                      model: {
                        value: _vm.form.model.subscribed,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.model, "subscribed", $$v)
                        },
                        expression: "form.model.subscribed",
                      },
                    },
                    [_vm._v("購読する")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui green button",
              class: { "loading disabled": _vm.form.waiting },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("保存する")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "action-menu" }, [
      _c(
        "button",
        {
          staticClass: "ui small positive button",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.openDialog()
            },
          },
        },
        [_c("i", { staticClass: "plus icon" }), _vm._v("新規登録\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "form",
      { staticClass: "ui form", class: { loading: _vm.loadForm.waiting } },
      [
        _c("table", { staticClass: "ui compact selectable table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.customers, function (customer) {
              return _c("tr", { key: customer.id }, [
                _c("td", [_vm._v(_vm._s(customer.name))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(customer.email))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(customer.area_label))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(customer.area_detail_label))]),
                _vm._v(" "),
                _c("td", { staticClass: "center aligned" }, [
                  customer.subscribed
                    ? _c("i", { staticClass: "green large check icon" })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui inverted tiny positive basic button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog(customer)
                        },
                      },
                    },
                    [_vm._v("編集")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ui inverted tiny negative basic button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.remove(customer)
                        },
                      },
                    },
                    [_vm._v("削除")]
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("顧客名")]),
        _vm._v(" "),
        _c("th", [_vm._v("メールアドレス")]),
        _vm._v(" "),
        _c("th", [_vm._v("エリア")]),
        _vm._v(" "),
        _c("th", [_vm._v("エリア詳細")]),
        _vm._v(" "),
        _c("th", { staticClass: "center aligned" }, [_vm._v("メルマガ購読中")]),
        _vm._v(" "),
        _c("th", { staticClass: "actions" }, [_vm._v(" ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }